export default [
  // async function example(to, from) {
  //   // ...
  // }
];
